import PropTypes from 'prop-types'
import React, { useState, useRef } from 'react'
import { Card, CardBody, CardHeader } from 'reactstrap'
import InputImageField from 'components/molecules/input-image-field'
import LoaderButton from 'components/molecules/loader-button'

const propTypes = {
  title                : PropTypes.string,
  onImageUpload        : PropTypes.func,
  onFileSelectionError : PropTypes.func,
  onSelectCoverPreview : PropTypes.func,
  multiple             : PropTypes.bool
}

const defaultProps = {
  title                : 'Upload Foto',
  onImageUpload        : () => {},
  onFileSelectionError : () => {},
  onSelectCoverPreview : () => {},
  multiple             : true
}

/**
 * @param {object} title - a string that's going to be the title of the upload card
 * @param {object} onImageUpload - a function that will be called when submit button is clicked
 * @param {object} onFileSelectionError - a function that will be passed to InputImageField, and will be called when the selected file doesn't match the requirement
 * @param {object} onSelectCoverPreview - a function that will be run when a new cover is selected
 * @param {boolean} multiple - a boolean to determine whether a user can upload multiple files or not
 */

const UploadImageCard = ({
  title,
  onImageUpload,
  onFileSelectionError,
  onSelectCoverPreview,
  multiple
}) => {
  const [ chosenImages, setChosenImages ]         = useState([])
  const [ cover, setCover ]                       = useState(null)
  const [ isImageUploading, setIsImageUploading ] = useState(false)

  const handleSubmit = () => {
    setIsImageUploading(true)
    const imageData = {
      images : chosenImages,
      cover  : cover
    }
    onImageUpload(imageData)
      .then( () => {
        fileInputRef.current.resetFile()
        setCover(null)
        setIsImageUploading(false)
      })
  }

  const handleSelectCover = (coverObject) => {
    setCover(coverObject.index)
    onSelectCoverPreview(coverObject.url)
  }

  const fileInputRef = useRef()

  return (
    <Card>
      <CardHeader>
        <h4><b>{ title }</b></h4>
      </CardHeader>
      <CardBody>
        <div className='d-flex'>
          <div>
            <InputImageField
              onSelectImages={ setChosenImages }
              onSelectCover={ handleSelectCover }
              onFileSelectionError={ onFileSelectionError }
              ref={ fileInputRef }
              multiple={ multiple }
            />
            { !chosenImages ?
              <div className='text-muted'>(Pilih foto dengan resolusi 1280 x 1280)</div>
              : ''
            }
          </div>
        </div>
        {
          chosenImages.length > 0 ?
            <div>
              <LoaderButton
                className='mt-3'
                color='primary'
                onClick={ handleSubmit }
                isLoading={ isImageUploading }
                text = 'Upload Foto'
              />
            </div> : null
        }
      </CardBody>
    </Card>
  )
}

UploadImageCard.propTypes    = propTypes
UploadImageCard.defaultProps = defaultProps

export default UploadImageCard
